import View from 'mixins/view';

export default class extends View {
    constructor(model) {
        super(model);
        this.setRootEl($(`<li class="covers-sliderItem"></li>`));
    }
    render() {
        const model = this.model;
        this.rootEl.html(`
          <a href="${model.get('url')}" class='covers-sliderItemHolder'
            style="background-image: url('${model.get('image')}');">
          </a>
          <a href="${model.get('url') || '#' }" class='covers-sliderItemTitle'>
            ${model.get('journal')}
          </a>
        `);
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/cover/cover-item-view.js